<div class="stepper">
  <button class="step-btn" [class.disabled]="!canDecrement" (click)="decrement()">
    <fa-icon [icon]="faMinus"></fa-icon>
  </button>
  <span class="value">{{ displayValue }}</span>
  <button class="step-btn" [class.disabled]="!canIncrement" (click)="increment()">
    <fa-icon [icon]="faPlus"></fa-icon>
  </button>
</div>
